import { render, staticRenderFns } from "./dashboard-insights.vue?vue&type=template&id=1e38bc12&scoped=true&"
import script from "./dashboard-insights.vue?vue&type=script&lang=js&"
export * from "./dashboard-insights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e38bc12",
  null
  
)

export default component.exports